import React from 'react'
export default function Experience({ items, lang, t }) {
  const es = lang === 'es'
  return (
    <section className="section" id="experience">
      <div className="container">
        <p className="eyebrow">{t.experience}</p>
        <div className="timeline">
          {items.map((e) => (
            <article className="timeline-item" key={e.company}>
              <div className="dot" />
              <div className="time">
                <b>{(es && e.companyEs) || e.company}</b>
                <span>{es ? e.periodEs : e.period}</span>
                <small>{es ? e.locationEs : e.location}</small>
              </div>
              <div className="job">
                <h3>{es ? e.roleEs : e.role}</h3>
                {e.stack && (
                  <p className="job-stack">
                    <b>{t.techStack}:</b> {e.stack}
                  </p>
                )}
                <ul>
                  {e.bullets[lang].map((x) => (
                    <li key={x}>{x}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
